import { combineReducers, configureStore } from "@reduxjs/toolkit";
import clientUserSlice from "./clientUserSlice";
import appTempSlice from "./appTempSlice";

const rootReducer = combineReducers({
  clientUser: clientUserSlice,
  appTemp: appTempSlice,
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;
